export default __webpack_public_path__ + "static/media/landing-page-img.3f10c734.png";